/* eslint-disable no-unused-vars */
import { Dispatch } from 'react';
import { FloorPlan, User } from '../__generated__/graphql';
import { FloorPlanData } from './dashboard.type';

export type AppState = {
  currentUser: User;
  authenticated: boolean;
  authToken: string | null;
  currentRole?: string;
  refreshToken?: string | null;
  setTourGuide: boolean;
  floorPlanSequence?: FloorPlanData;
  floorPlan: FloorPlan;
  routerPrompt: boolean;
};

export enum AppActionType {
  setCurrentUser = 'SET_CURRENT_USER',
  setAuthenticated = 'SET_AUTHENTICATED',
  setAuthToken = 'SET_TOKEN',
  setCurrentRole = 'SET_CURRENT_ROLE',
  setRefreshToken = 'SET_REFRESH_TOKEN',
  logout = 'LOGOUT',
  setTourGuide = 'TOUR_GUIDE',
  setFloorPlanSequence = 'SET_FLOOR_PLAN_SEQUENCE',
  getFloorPlanSequence = 'GET_FLOOR_PLAN_SEQUENCE',
  removeFloorPlanSequence = 'REMOVE_FLOOR_PLAN_SEQUENCE',
  setFloorPlan = 'SET_FLOOR_PLAN',
  getFloorPlan = 'GET_FLOOR_PLAN',
  setRouterPrompt = 'SET_ROUTER_PROMPT',
}

export type AppAction =
  | { type: AppActionType.setCurrentUser; data: User }
  | { type: AppActionType.setAuthenticated; data: boolean }
  | { type: AppActionType.setAuthToken; data: string | null }
  | { type: AppActionType.setRefreshToken; data: string | null }
  | { type: AppActionType.setCurrentRole; data: string }
  | { type: AppActionType.logout }
  | { type: AppActionType.setTourGuide; data: boolean }
  | { type: AppActionType.setFloorPlanSequence; data: FloorPlanData }
  | { type: AppActionType.getFloorPlanSequence }
  | { type: AppActionType.removeFloorPlanSequence }
  | { type: AppActionType.setFloorPlan; data: FloorPlan }
  | { type: AppActionType.getFloorPlan }
  | { type: AppActionType.setRouterPrompt; data: boolean };

export type AppContextType = {
  state: AppState;
  dispatch: Dispatch<AppAction>;
  getToken: () => string | null;
  isAuthenticated: () => boolean;
  getRefreshToken: () => string | null;
  initializeAuth: (
    authToken: string | null,
    userData: User | null,
    refreshToken?: string | null,
  ) => void;
  getCurrentUser: () => void;
  getStoredFloorPlanSequence: () => void;
  getStoredFloorPlan: () => void;
};
